import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import GeneralDataServices from "./GeneralData.services"
import GeneralInfoServices from "../GeneralInfo/GeneralInfo.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getGeneralData = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_GENERAL_DATA,
      payload: true,
    });
    const resp = await GeneralDataServices.getGeneralData(filters);
    dispatch({
      type: actions.GET_GENERAL_DATA,
      payload: {
        generalData: resp.data.data,
        generalDataLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.GENERAL_DATA_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.GENERAL_DATA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_GENERAL_DATA,
      payload: false,
    });
  }
};

export const getGeneralDataById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_GENERAL_DATA_BY_ID,
      payload: true,
    });
    const resp = await GeneralDataServices.getGeneralDataById(id);
    dispatch({
      type: actions.GET_GENERAL_DATA,
      payload: {
        generalData: resp.data
      },
    });
    dispatch({
      type: actions.GENERAL_DATA_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.GENERAL_DATA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_GENERAL_DATA_BY_ID,
      payload: false,
    });
  }
};

export const saveGeneralData = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_GENERAL_DATA,
      payload: true,
    });
    const resp = await GeneralDataServices.saveGeneralData(data);
    const { generalData, generalDataLength } = getState().generalData;
    const _generalData = [...generalData, resp.data];
    dispatch({
      type: actions.GET_GENERAL_DATA,
      payload: {
        generalData: _generalData,
        generalDataLength: generalDataLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: {},
    });
    //setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_GENERAL_DATA,
      payload: false,
    });
  }
};

export const editGeneralData = (data, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_GENERAL_DATA,
      payload: true,
    });
    const resp = await GeneralDataServices.editGeneralData(id, data);
    const { generalData, generalDataLength } = getState().generalData;
    const dataT = resp.data;
    //generalData[index] = dataT;
    dispatch({
      type: actions.GET_GENERAL_DATA,
      payload: {
        generalData: generalData,
        generalDataLength: generalDataLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    //setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
    const _data = {
      data:[
        {
          funcion_descriptor:dataT.posicion,
          tipo_mensaje:"Jefe actualiza descriptor"
        }
      ]
    }
    await GeneralInfoServices.mailSendGeneralInfo(_data);
    toastr.success(messages.correoEnviado, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            if(ex.response.statusText){
              message = messages.errorMessage + " " + ex.response.statusText;
            }else{
              message = messages.errorMessage;
            }
            break;
          default:
            if(ex.response.data && ex.response.data.detail){
              message = ex.response.data.detail;
            }else if(ex.response.data){
              message = ex.response.data;
            }else{
              message = messages.errorMessage;
            }
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_GENERAL_DATA,
      payload: false,
    });
  }
};

export const deleteGeneralData = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_GENERAL_DATA,
      payload: true,
    });
    await GeneralDataServices.deleteGeneralData(id);
    const { generalData, generalDataLength } = getState().generalData;
    generalData.splice(index, 1);
    dispatch({
      type: actions.GET_GENERAL_DATA,
      payload: {
        generalData: generalData,
        generalDataLength: generalDataLength - 1,
      },
    });
    dispatch({
      type: actions.GENERAL_DATA_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.GENERAL_DATA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_GENERAL_DATA,
      payload: false,
    });
  }
};